<template>
  <template v-if="loading">
    <skeleton-content-collection v-for="index in 4" :key="`loader-${index}`" />
  </template>
  <template v-else>
    <template v-if="!userAuthStore.features.ADS_FREE && showUnits">
      <collection-unit
        v-for="index in 4"
        v-show="index <= collectionTotal"
        :key="`unit${index}`"
        :style="{ order: index * markUnitInterval }"
        :unit-slot-id="103"
        google-unit-id="1334371830"
      />
    </template>

    <slot :collection-order="collectionOrder" />
  </template>
</template>

<script setup lang="ts">
import { useUserAuthStore } from '@/stores/user-auth'
import SkeletonContentCollection from '@/components/loaders/skeleton-content-collection.vue'
import CollectionUnit from '@/components/units/collection-unit.vue'

/** PROPS **/
withDefaults(
  defineProps<{
    loading?: boolean
    collectionTotal: number
    showUnits?: boolean
  }>(),
  {
    loading: false,
    showUnits: true,
  },
)

/** STATE **/
const userAuthStore = useUserAuthStore()

/** NON REACTIVE **/
const markUnitInterval = 2

/** EMITS **/

/** COMPUTED **/

/** METHODS **/
function collectionOrder(index: number) {
  let indexBaseOne = index + 1

  // increment for each unit index
  ;[2, 4, 6, 8].forEach((unitIndex) => {
    if (indexBaseOne >= unitIndex) {
      indexBaseOne += 1
    }
  })

  return indexBaseOne
}
</script>
